module.exports = __webpack_public_path__ + "img/logo.bc974ba6.png";